import { formatDate } from './dateTime';

export default (app) => {
  app.config.globalProperties.$filters = {
    formatDate,
  };
};
